<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-mb-4 ts-flex ts-justify-between">
        <div class="ts-flex ts-items-center ts-space-x-2">
          <a-select v-model="branch_id" mode="multiple" :placeholder="$t('studentInsurance.selectBranch')" show-search
            :filter-option="filterOption" option-filter-prop="children" style="width: 230px" :options="branchOptionns"
            :maxTagTextLength="10" :maxTagCount="1" allowClear @change="fetchAcademicYear"></a-select>
          <a-select v-model="ac_year_id" mode="multiple" :placeholder="$t('studentInsurance.selectAcademicYear')"
            style="width: 230px" :maxTagTextLength="25" :maxTagCount="1" allowClear>
            <a-select-opt-group v-for="(option, index) in acYearOptionns" :key="index">
              <span slot="label">{{ option.label }}</span>
              <a-select-option v-for="(opt, index) in option.options" :key="index" :value="opt.value">
                {{ opt.label }}
              </a-select-option>
            </a-select-opt-group>
          </a-select>
          <a-range-picker v-model="dateRange" format="DD-MM-YYYY" valueFormat="YYYY-MM-DD"
            style="max-width: 200px;"></a-range-picker>
          <a-radio-group v-model="is_new_student" button-style="solid">
            <a-radio-button :value="undefined">
              {{ $t('studentInsurance.all') }}
            </a-radio-button>
            <a-radio-button :value="1">
              {{ $t('studentInsurance.new') }}
            </a-radio-button>
            <a-radio-button :value="0">
              {{ $t('studentInsurance.old') }}
            </a-radio-button>
          </a-radio-group>

          <a-radio-group v-model="insuration_converted" button-style="solid">
            <a-radio-button :value="undefined">
              {{ $t('studentInsurance.all') }}
            </a-radio-button>
            <a-radio-button :value="1">
              {{ $t('studentInsurance.converted') }}
            </a-radio-button>
            <a-radio-button :value="0">
              {{ $t('studentInsurance.notConverted') }}
            </a-radio-button>
          </a-radio-group>
        </div>
        <div class="ts-space-x-3">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ $t('studentInsurance.search') }}</span>
            </template>
            <a-input-search v-model="search" @search="fetchData({ search: search })"
              :placeholder="$t('studentInsurance.failedSearch')" style="width: 200px" />
          </a-tooltip>
          <a-button type="primary" @click="fetchData">
            {{ $t('search') }}
          </a-button>
        </div>
      </div>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.ac_year }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.full_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.inv_number }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.description }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.insuration_converted_reason }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.created_at }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-center">
              <a v-if="record.insuration_converted === false" href="#"
                class="ts-text-blue-500 hover:ts-text-blue-700 ts-cursor-pointer"
                @click.prevent="onClickConvert(record)">
                <i class="fas fa-share"></i>
              </a>
            </td>
          </template>
        </ts-table>
        <div class="d-flex justify-content-between align-items-center p-15">
          <ts-total-list v-model="pagination" />
          <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
        </div>

        <a-modal v-model="showModalInsurance" v-if="showModalInsurance" :title="$t('studentprofile.insurance')"
          :footer="null" width="400px" @cancel="onClickClose">
          <InsuranceConvert :selected="selected" @close="onClickClose" @fetch="onClickClose" />
        </a-modal>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { camelCase, mapKeys } from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'
import InsuranceConvert from './insurance-convert.vue'

class Pagination {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}

export default {
  name: 'failedInsurance',
  props: {
    branches: {
      type: Array,
      default: () => []
    }
  },
  components: {
    InsuranceConvert
  },
  data() {
    return {
      loading: false,
      showModalInsurance: false,
      resources: [],
      pagination: new Pagination(),
      selected: {},
      acYearOptionns: [],
      branch_id: undefined,
      ac_year_id: undefined,
      search: undefined,
      is_new_student: undefined,
      insuration_converted: 0,
      dateRange: [
        moment().format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD')
      ]
    }
  },
  computed: {
    branchOptionns() {
      return this.branches.map(branch => ({
        value: branch.branch_id,
        label: branch.branch_name_en
      }))
    },
    columns() {
      return [
        {
          name: this.$t('studentInsurance.branch'),
          sortKey: 'branch.branch_name_en'
        },
        {
          name: this.$t('studentInsurance.academicYear')
        },
        {
          name: this.$t('studentInsurance.studentName')
        },
        {
          name: this.$t('studentInsurance.invoiceNumber')
        },
        {
          name: this.$t('studentInsurance.remark')
        },
        {
          name: this.$t('studentInsurance.reason')
        },
        {
          name: this.$t('studentInsurance.createdAt')
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:5%'
        }
      ]
    },
    academicStatusName: () => academicStatus => {
      switch (academicStatus) {
        case 1:
          return 'Current'
        case 2:
          return 'History'
        case 3:
          return 'Next'
        default:
          return ''
      }
    }
  },
  async mounted() {
    this.branch_id = this.$store.state.authUser.default_branch_id || undefined
    await this.fetchAcademicYear()
    await this.fetchData()
  },
  methods: {
    ...mapActions('studentInsurance', ['formViewModel']),
    async fetchAcademicYear() {
      this.ac_year_id = undefined
      this.acYearOptionns = []
      this.loading = true
      const response = await this.formViewModel({
        fnName: 'academic_year',
        branch_id: this.branch_id
      })
      this.loading = false

      const findCurrentAcYear = response.academic_year.find(a => a.branch_id == this.branch_id && a.ac_status_id == 1)

      if (findCurrentAcYear) {
        this.ac_year_id = findCurrentAcYear.ac_year_id
      }

      // Transform data and group by status
      const groupedData = response.academic_year.reduce((acc, ac) => {
        const status = this.academicStatusName(ac.ac_status_id)
        const option = {
          value: ac.ac_year_id,
          label: `${ac.ac_year}-${ac.branch_name_en}`
        }

        const existingGroup = acc.find(group => group.label === status)
        if (existingGroup) {
          existingGroup.options.push(option)
        } else {
          acc.push({
            label: status,
            options: [option]
          })
        }
        return acc
      }, [])
      this.acYearOptionns = groupedData
    },
    fetchData(attributes = {}) {
      this.loading = true
      this.$store
        .dispatch('studentInsurance/failedInsurance', {
          branch_id: this.branch_id,
          ac_year_id: this.ac_year_id,
          search: this.search,
          is_new_student: this.is_new_student,
          insuration_converted: this.insuration_converted,
          ...attributes,
          date_range: this.dateRange
        })
        .then(response => {
          this.RECEIVE_RESOURCES(response)
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    RECEIVE_RESOURCES(response) {
      this.resources = []
      response.data.forEach(resource => {
        this.resources.push(Object.assign(resource, { _deleting: false }))
      })
      if (response.hasOwnProperty('meta')) {
        this.pagination = new Pagination(
          mapKeys(response.meta, (v, k) => camelCase(k))
        )
      } else {
        let { data, ...meta } = response
        this.pagination = new Pagination(mapKeys(meta, (v, k) => camelCase(k)))
      }
    },
    onClickConvert(record) {
      this.selected = record
      this.showModalInsurance = true
    },
    onClickClose() {
      this.showModalInsurance = false
      this.selected = {}
      this.fetchData({
        branch_id: this.branch_id,
        ac_year_id: this.ac_year_id,
        search: this.search,
        is_new_student: this.is_new_student,
        insuration_converted: this.insuration_converted
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>
